// extracted by mini-css-extract-plugin
export var actionButtonsWrapper = "audits-module--actionButtonsWrapper--1f180";
export var auditsPlaceholderImage = "audits-module--audits-placeholder-image--a8b43";
export var auditsPlaceholderImageButtons = "audits-module--audits-placeholder-image-buttons--77a1c";
export var auditsPlaceholderText = "audits-module--audits-placeholder-text--4491c";
export var coordinatesButton = "audits-module--coordinates-button--824ed";
export var deleteForm = "audits-module--delete-form--a20f9";
export var description = "audits-module--description--7638c";
export var divider = "audits-module--divider--d76c5";
export var draftText = "audits-module--draftText--58896";
export var editAuditTopRow = "audits-module--editAuditTopRow--c4d62";
export var filterHeading = "audits-module--filter-heading--9d3d9";
export var form = "audits-module--form--2b65b";
export var heading = "audits-module--heading--12746";
export var icon = "audits-module--icon--620c5";
export var iconTextContainer = "audits-module--iconTextContainer--a3ca7";
export var importDownloadExample = "audits-module--import-download-example--5c35c";
export var importForm = "audits-module--import-form--83d60";
export var infoList = "audits-module--infoList--91a99";
export var locationsWrapper = "audits-module--locationsWrapper--86c6a";
export var saveCancelReviewButtonSet = "audits-module--saveCancelReviewButtonSet--bdffc";
export var smartAuditPlaceholderButton = "audits-module--smart-audit-placeholder-button--61f57";
export var status = "audits-module--status--0a382";
export var toggle = "audits-module--toggle--3fc57";
export var toggleField = "audits-module--toggle-field--a7a97";
export var toggleLabel = "audits-module--toggle-label--6cc22";
export var topRowItem = "audits-module--topRowItem--62716";
export var warehouseDescription = "audits-module--warehouse-description--dd565";